module.exports = __webpack_public_path__ + "static/media/kindergarten_icon.01292a94.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kindergarten_icon.svg
// module id = 250
// module chunks = 0